import WhiteSpace from 'antd-mobile/lib/white-space';
export default WhiteSpace;



// WEBPACK FOOTER //
// ./components/white-space/index.tsx